import { useEffect, useState } from "react";

/**
 * Returns a debounced copy of `value` that only updates once `delay` ms have
 * passed without a change. Used to keep keystroke-driven inputs (e.g. the
 * candidate pool search box) from re-firing a network query on every key.
 */
export function useDebounce<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
